import { Card, Form, Button, InputNumber, message } from "antd"
import * as API from "common/api"
import * as COMMONS from "common/common"
import "moment/locale/ja"
import React, { useEffect } from "react"
import { useMutation, useQueryClient } from "react-query"
import { Helmet } from "react-helmet-async"
import { useNavigate } from "react-router-dom"

const Point = (props) => {
  const { systemSettings } = props

  const navigate = useNavigate()

  const isMountedRef = COMMONS.USE_IS_MOUNTED_REF()
  const queryClient = useQueryClient()

  const [giftPointSettingsForm] = Form.useForm()

  const giftPointSettingsMutation = useMutation(API.ADMIN_UPDATE_SETTINGS, {
    onSuccess: () => {
      if (isMountedRef.current) {
        message.success(COMMONS.SUCCESS_SAVE_MSG)
        queryClient.invalidateQueries(API.QUERY_KEY_ADMIN_SETTINGS)
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  useEffect(() => {
    giftPointSettingsForm.setFieldsValue({
      giftPointNewRegister:
        systemSettings?.giftPointNewRegister?.valueNumber || 0,
      giftPointLineSync: systemSettings?.giftPointLineSync?.valueNumber || 0,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemSettings])

  const handleGiftPointSettings = (data) => {
    const paramData = [
      {
        label: API.SETTINGS_LABEL_GIFT_POINT_NEW_REGISTER,
        settingName: API.SETTINGS_KEY_GIFT_POINT_NEW_REGISTER,
        value: data.giftPointNewRegister,
        isPublic: true,
      },
      {
        label: API.SETTINGS_LABEL_GIFT_POINT_LINE_SYNC,
        settingName: API.SETTINGS_KEY_GIFT_POINT_LINE_SYNC,
        value: data.giftPointLineSync,
        isPublic: true,
      },
    ]

    giftPointSettingsMutation.mutate(paramData)
  }

  return (
    <>
      <Helmet>
        <title>ポイント設定 | {process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <Card
        title="ポイント設定"
        className="animate__animated animate__fadeIn"
        bordered={false}
      >
        <Card
          type="inner"
          title="ポイントプレゼント設定"
          extra={
            <Button
              type="primary"
              size="large"
              className="w-32 m-1"
              onClick={() => {
                giftPointSettingsForm.submit()
              }}
            >
              保存
            </Button>
          }
        >
          <Form
            form={giftPointSettingsForm}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign="left"
            initialValues={{
              giftPointNewRegister: 0,
              giftPointLineSync: 0,
            }}
            onFinish={handleGiftPointSettings}
            requiredMark={false}
            colon={false}
            size="large"
            scrollToFirstError
          >
            <Form.Item
              name="giftPointNewRegister"
              label="メール登録"
              rules={[
                {
                  required: true,
                  message: "必須です",
                },
              ]}
            >
              <InputNumber
                placeholder="例：100"
                addonAfter="P"
                min={0}
                type="number"
                onPressEnter={(e) => {
                  e.preventDefault()
                }}
              />
            </Form.Item>
            <Form.Item
              name="giftPointLineSync"
              label="LINE連携"
              rules={[
                {
                  required: true,
                  message: "必須です",
                },
              ]}
            >
              <InputNumber
                placeholder="例：100"
                addonAfter="P"
                min={0}
                type="number"
                onPressEnter={(e) => {
                  e.preventDefault()
                }}
              />
            </Form.Item>
          </Form>
        </Card>
      </Card>
    </>
  )
}

export default Point
